import {fsa, fsaError, fsaPayload} from './helpers'

/**
 * GET order items to exchange API actions
 */
export const GET_ORDER_ITEMS_TO_EXCHANGE = 'get order items to exchange'
export const getOrderItemsToExchange = fsa(GET_ORDER_ITEMS_TO_EXCHANGE)

export const GET_ORDER_ITEMS_TO_EXCHANGE_PENDING = 'get order items to exchange pending'
export const getOrderItemsToExchangePending = fsa(GET_ORDER_ITEMS_TO_EXCHANGE_PENDING)

export const GET_ORDER_ITEMS_TO_EXCHANGE_SUCCESS =
  'get order items to exchange successfully fetched'
export const getOrderItemsToExchangeSuccess = fsaPayload(GET_ORDER_ITEMS_TO_EXCHANGE_SUCCESS)

export const GET_ORDER_ITEMS_TO_EXCHANGE_FAILURE = 'get order items to exchange failed'
export const getOrderItemsToExchangeFailure = fsaError(GET_ORDER_ITEMS_TO_EXCHANGE_FAILURE)

/**
 * GET all user orders
 */
export const GET_ALL_USER_ORDERS = 'order/get all user orders'
export const getAllUserOrders = fsa(GET_ALL_USER_ORDERS)

export const GET_ALL_USER_ORDERS_FAILURE = 'order/get all user orders failure'
export const getAllUserOrdersFailure = fsaError(GET_ALL_USER_ORDERS_FAILURE)

export const GET_ALL_USER_ORDERS_PENDING = 'order/get all user orders pending'
export const getAllUserOrdersPending = fsa(GET_ALL_USER_ORDERS_PENDING)

export const GET_ALL_USER_ORDERS_SUCCESS = 'order/get all user orders success'
export const getAllUserOrdersSuccess = fsaPayload(GET_ALL_USER_ORDERS_SUCCESS)
